<template>
  <div class="sy-page">
    <div class="fwl-title">
      <img src="../../assets/icon/fwl.png" width="25" height="25" >
      <span style="font-weight: bolder; color: black; margin-left: 20px">访问量</span>
    </div>
    <div class="fwl">
      <div class="fwl-con">
        <div class="fwl-content">
          <img src="../../assets/logo.png" width="40px" height="40px">
          <div class="fwl-content-son">
            <span>今日访问量</span>
            <span class="see-num">{{todaySeeNum}}人</span>
          </div>
        </div>
      </div>
      <div class="fwl-con">
        <div class="fwl-content">
          <img src="../../assets/logo.png" width="40px" height="40px">
          <div class="fwl-content-son">
            <span>昨日访问量</span>
            <span class="see-num">{{yesSeeNum}}人</span>
          </div>
        </div>
      </div>
      <div class="fwl-con">
        <div class="fwl-content">
          <img src="../../assets/logo.png" width="40px" height="40px">
          <div class="fwl-content-son">
            <span>近一周访问量</span>
            <span class="see-num">{{weekSeeNum}}人</span>
          </div>
        </div>
      </div>
      <div class="fwl-con">
        <div class="fwl-content">
          <img src="../../assets/logo.png" width="40px" height="40px">
          <div class="fwl-content-son">
            <span>本月访问量</span>
            <span class="see-num">{{monthSeeNum}}人</span>
          </div>
        </div>
      </div>
    </div>
    <div class="user-and-logrecord">
        <div class="log-record">
          <div class="fwl-zx-title">
            <div>
              <img src="../../assets/icon/zxt.png" width="25" height="25" >
              <span style="font-weight: bolder; color: black; margin-left: 20px">最近一周访问曲线</span>
            </div>
          </div>
          <div style="padding: 15px; height: 100%" >
            <div id="main" style="width: 100%;height:90%;"></div>
          </div>
        </div>
        <div class="user-manager">
          <div class="fwl-zx-title">
            <div>
              <img src="../../assets/icon/user-manager.png" width="25" height="25" >
              <span style="font-weight: bolder; color: black; margin-left: 20px">系统用户信息管理</span>
            </div>
            <div style="float: right; width: 300px">
              <el-input
                v-model="search"
                size="mini"
                class="searchClass"
                placeholder="输入（标题）关键字"/>
            </div>
          </div>
          <div style="padding: 15px">
            <el-table
              :data="tableData"
              style="width: 100%;">
              <el-table-column
                label="序号"
                prop="id">
              </el-table-column>
              <el-table-column
                label="用户名"
                prop="userName">
              </el-table-column>
              <el-table-column
                label="生日"
                prop="birth">
              </el-table-column>
              <el-table-column
                label="性别"
                prop="sex">
              </el-table-column>
              <el-table-column
                label="家庭住址"
                prop="home">
              </el-table-column>
              <el-table-column
                align="center" label="操作">
                <template slot-scope="scope" >
                  <!--el-icon-view-->
                  <i class="el-icon-view" style="color: blue"  @click="handleEdit(scope.row)"></i>
                  <i class="el-icon-delete" style="color: red; margin-left: 15px"  @click="handleDelete(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
    </div>
    <div>
      <el-dialog title="用户信息" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="用户名" :label-width="formLabelWidth">
            <el-input v-model="form.userName" readonly="readonly" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="出生年月" :label-width="formLabelWidth">
            <el-input v-model="form.birth" readonly="readonly"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="性别" :label-width="formLabelWidth">
            <el-input v-model="form.sex" readonly="readonly"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="家庭住址" :label-width="formLabelWidth">
            <el-input v-model="form.home" readonly="readonly"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="自我介绍" :label-width="formLabelWidth">
            <el-input type="textarea" readonly="readonly"  :rows="3" v-model="form.aboutUs" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">关  闭</el-button>
       <!--   <el-button type="primary" @click="handleEditConfirm">确 定</el-button>-->
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import { syVisitInfo } from '../../request/api';
  import { getUserList } from '../../request/api';
  import { delUser } from '../../request/api';

  export default {
    data() {
      return {
        search: '',
        todaySeeNum: 0,
        yesSeeNum: 0,
        weekSeeNum: 0,
        monthSeeNum: 0,
        tableData: [],
        opinionData: ["2","3","4","1","4","6","7"],
        dialogFormVisible: false,
        formLabelWidth: '120px',
        form: {
          userName: '',
          birth: '',
          sex: '',
          home: '',
          aboutUs: ''
        },
        visitList: []
      }
    },
    methods: {
      getVisitInfo() {
        let param = {}
        // 提交登录请求
        syVisitInfo(param).then(
          resp => {
            if (resp.code === 1) {
              this.msg = "成功";
              this.todaySeeNum = resp.data.todayNum;
              this.yesSeeNum = resp.data.yesDayNum;
              this.weekSeeNum = resp.data.weekNum;
              this.monthSeeNum = resp.data.monthNum;
              this.visitList = resp.data.weekVisitList;

              let option = this.lineChart.getOption();
              option.series[0].data = resp.data.weekVisitList;
              this.lineChart.setOption(option);
            } else {
              this.msg = resp.msg;
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      getUserList() {
        let param = {
          userName: this.search
        }
        // 提交登录请求
        getUserList(param).then(
          resp => {
            if (resp.code === 1) {
              this.tableData = resp.data
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      drawLine() {
        this.lineChart = echarts.init(document.getElementById('main'))

        let option = {
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: this.visitList,
              type: 'line',
              areaStyle: {}
            }
          ]
        };
        this.lineChart.setOption(option);
      },

      handleEdit(row) {
        this.dialogFormVisible = true;
        this.form.userName = row.userName;
        this.form.birth = row.birth;
        this.form.sex = row.sex;
        this.form.home = row.home;
        this.form.aboutUs = row.aboutUs;
      },
      handleEditConfirm(index, row) {
        console.log(index, row);
        this.$confirm('确定修改如下信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
          this.dialogFormVisible = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改'
          });
        });
      },
      handleDelete(row) {
        console.log("记录:" + row);
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {
            id: row.id
          }
          // 提交登录请求
          delUser(param).then(
            resp => {
              if (resp.code === 1) {
                this.$message.success(resp.msg);
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getUserList();
              } else {
                this.msg = resp.msg;
                this.$message.error(resp.msg);
              }
            }
          ).catch(err => {
            console.log(err)
          })


        }).catch(() => {
          this.$message({
            type: 'error',
            message: '操作出现异常'
          });
        });
      }
    },
    mounted() {
      this.$nextTick(function () {
        this.drawLine();
      });
      // 获取统计信息
      this.getVisitInfo();
      // 获取用户信息
      this.getUserList();
      // 重绘统计图
      window.addEventListener('resize',() => {
        this.lineChart.resize();
      })
    }
  };
</script>

<style>
  .sy-page {
    height: 100%;
    background-color: #ecf6f9;
    text-align: center;
    padding-top: 30px;
    overflow-y: auto;
  }

  .fwl-title {
    width: 94%;
    margin-left: 3%;
    display: flex;
    align-items: center;
  }


  .fwl {
    display: flex;
    width: 94%;
    margin-left: 3%;
    margin-top: 10px;
    justify-content: space-between;
  }

  .fwl-con {
    width: 23%;
    height: 150px;
    background-color: white;
    display: flex;
    justify-content: space-around;
  }
  .fwl-content {
    display: flex;
    align-items: center;
  }

  .fwl-content-son {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
  }

  .see-num {
    margin-top: 8px;
    color: blue;
  }

  .user-and-logrecord {
    margin-top: 50px;
    display: flex;
    height: calc(100vh - 400px);
    width: 94%;
    margin-left: 3%;
    flex-direction: row;
    justify-content: space-around;
    min-height: 355px;
  }

  .log-record {
    width: 40%;
    /*height: 355px;*/
    background-color: white;
  }
  .user-manager {
    margin-left: 2%;
    /*height: 355px;*/
    /*height: calc(100vh - 400px);*/
    width: 58%;
    background-color: white;
  }

  .fwl-zx-title {
    width: 94%;
    margin-left: 3%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .el-table .el-table__body-wrapper {
    height: calc(100vh - 510px);
    min-height: 250px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/sy/index.vue